"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.number.constructor");









































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = { name: 'Intention', props: { apply: { type: Object, default: function _default() {return { id: '', applyCode: '', standardSlot: '' };} }, value: Number }, data: function data() {return { handleShow: false, tableData: [], // 列表数据
      patients: [], id: '', searchData: { name: '', mobile: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'name', label: '姓名', isShow: true }, { prop: 'sex', label: '性别', formatter: function formatter(row, column, val) {return val === 1 ? '男' : '女';}, isShow: true }, { prop: 'mobile', label: '电话', isShow: true }, { prop: 'hospitalTime', formatter: _formatter.dateSimpleFormatter, label: '入院时间', isShow: true }] };}, watch: { value: function value(oldV, newV) {// 监听父组件的变化
      this.id = oldV;} }, mounted: function mounted() {var self = this;console.log('id', self.id);self.init();}, methods: { init: function init() {var self = this;self.getData('/api/temi/medical/patient', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission,
    resetFun: function resetFun() {// 重置
      this.searchData.name = '';
      this.searchData.mobile = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleClose: function handleClose() {
      this.handleShow = false;
    },
    handleCheckRow: function handleCheckRow(row) {
      // self.value = row.id
      /*
      self.apply.id = row.id
      self.apply.name = row.name
      self.apply.merchant = row.merchant
      self.apply.voicePlatform = row.voicePlatform
      */
      // this.$emit('getCheckEvent', event)
    },
    sendMsgToParent: function sendMsgToParent() {
      var self = this;
      self.$emit('sendMsgToParent', self.patients);
      self.handleShow = false;
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    closeDiglog: function closeDiglog() {
      this.handleShow = false;
    } } };exports.default = _default2;